















import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { WithAppContext } from '@/mixins';

import DesktopCheckoutView from '@/components/checkout/DesktopCheckoutView.vue';
import MobileCheckoutView from '@/components/checkout/MobileCheckoutView.vue';

@Component({
  components: {
    DesktopCheckoutView,
    MobileCheckoutView,
  },
})
export default class Checkout extends mixins(WithAppContext) {
  public orderId!: string;

  public created() {
    const orderId = this.$route.params.draftOrderId;
    if (!orderId) {
      throw new Error('expected an order id');
    }
    this.orderId = orderId;
  }
}

